export default __webpack_public_path__ + "static/media/active-employees.8dbd23b5.svg";